const SNS = {
  "twitter": "https://twitter.com/{TWITTER ID}",
  "facebook": "https://facebook.com/{FACEBOOK ID}",
  "instagram": "https://instagram.com/tanabe.tax/",
  "lineUrl": "https://line.me/{LINE@ ID}",
  "lineName": "{LINE NAME}",
}

export default SNS;